import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import ru from 'vuetify/es5/locale/ru'

// Icons
import { library as faLibrary } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
    faCircle as fasCircle,
    faCheckSquare as fasCheckSquare,
    faStar as fasStar,
    //
    faAngleDown as falAngleDown,
    faCalendarAlt as falCalendarAlt,
    faClock as falClock,
    faCreditCard as falCreditCard,
    faPlus as falPlus,
    faStarHalfAlt as falStarHalfAlt,
    // faStar as falStar,
    faSquare as falSquare,
    faTimes as falTimes,
    faTools as falTools,
    faArrowLeft as farArrowLeft,
    faArrowRight as farArrowRight,
    faBars as farBars,
    faWarehouse as farCarGarage,
    faPercent as farPercent,
    faChevronLeft as farChevronLeft,
    faChevronRight as farChevronRight,
} from '@fortawesome/free-solid-svg-icons'
import {
    faStar as falStar,
} from '@fortawesome/free-regular-svg-icons'
// import {
//     faAngleDown as falAngleDown,
//     faCalendarAlt as falCalendarAlt,
//     faClock as falClock,
//     faCreditCard as falCreditCard,
//     faPlus as falPlus,
//     faStarHalfAlt as falStarHalfAlt,
//     faStar as falStar,
//     faSquare as falSquare,
//     faTimes as falTimes,
//     faTools as falTools,
// } from '@fortawesome/pro-light-svg-icons'

const makeIconComponentDeclaration = icon => {
    faLibrary.add(icon)

    return {
        component: FontAwesomeIcon,
        props: {
            icon: [icon.prefix, icon.iconName],
        },
    }
}

const MY_ICONS = {
    // complete: '...',
    // cancel: '...',
    close: makeIconComponentDeclaration(falTimes),
    delete: makeIconComponentDeclaration(falTimes), // delete (e.g. v-chip close)
    clear: makeIconComponentDeclaration(falTimes),
    // success: '...',
    // info: '...',
    // warning: '...',
    // error: '...',
    prev: makeIconComponentDeclaration(farArrowLeft),
    next: makeIconComponentDeclaration(farArrowRight),
    checkboxOn: makeIconComponentDeclaration(fasCheckSquare),
    checkboxOff: makeIconComponentDeclaration(falSquare),
    // checkboxIndeterminate: '...',
    delimiter: makeIconComponentDeclaration(fasCircle), // for carousel
    // sort: '...',
    // expand: '...',
    // menu: '...',
    // subgroup: '...',
    dropdown: makeIconComponentDeclaration(falAngleDown),
    // radioOn: '...',
    // radioOff: '...',
    // edit: '...',
    ratingEmpty: makeIconComponentDeclaration(falStar),
    ratingFull: makeIconComponentDeclaration(fasStar),
    ratingHalf: makeIconComponentDeclaration(falStarHalfAlt),
    // loading: '...',
    // first: '...',
    // last: '...',
    // unfold: '...',
    // file: '...',
    //
    arrowLeft: makeIconComponentDeclaration(farArrowLeft),
    arrowRight: makeIconComponentDeclaration(farArrowRight),
    bars: makeIconComponentDeclaration(farBars),
    calendarAlt: makeIconComponentDeclaration(falCalendarAlt),
    carGarage: makeIconComponentDeclaration(farCarGarage),
    clock: makeIconComponentDeclaration(falClock),
    creditCard: makeIconComponentDeclaration(falCreditCard),
    percent: makeIconComponentDeclaration(farPercent),
    plus: makeIconComponentDeclaration(falPlus),
    tools: makeIconComponentDeclaration(falTools),
    chevronLeft: makeIconComponentDeclaration(farChevronLeft),
    chevronRight: makeIconComponentDeclaration(farChevronRight),
}

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(Vuetify)

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#3fab3e',
                secondary: '#f22319',
                // accent: '#82b1ff',
                // error: '#f22319',
                // info: '#2196f3',
                // success: '#4caf50',
                // warning: '#ffc107',
            },
        },
    },
    lang: {
        locales: { ru },
        current: 'ru',
    },
    icons: {
        values: MY_ICONS,
    },
})
